module.exports = __webpack_public_path__ + "static/img/shoonya_logo.1937b07.png";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/shoonya_logo.png
// module id = t9I5
// module chunks = 1 7